import { Routes, Route } from 'react-router'
import { Toaster } from 'sonner'
import Layout from './components/Layout.tsx'
import ScrollToTop from './components/ScrollToTop.tsx'
import { DocumentHead } from './components/DocumentHead.tsx'
import HomePage from './pages/HomePage.tsx'
import NewsPage from './pages/NewsPage.tsx'
import NewsDetailPage from './pages/NewsDetailPage.tsx'
import ProjectsPage from './pages/ProjectsPage.tsx'
import ProjectDetailPage from './pages/ProjectDetailPage.tsx'
import ReportsPage from './pages/ReportsPage.tsx'
import ReportDetailPage from './pages/ReportDetailPage.tsx'
import StatisticsPage from './pages/StatisticsPage.tsx'
import StatisticsDetailPage from './pages/StatisticsDetailPage.tsx'
import HealthStatisticsPage from './pages/HealthStatisticsPage.tsx'
import DesilStatisticsPage from './pages/DesilStatisticsPage.tsx'
import DesaTentangPage from './pages/DesaTentangPage.tsx'
import DesaLokasiPage from './pages/DesaLokasiPage.tsx'
import BukuTamuPage from './pages/BukuTamuPage.tsx'

function App() {
  return (
    <>
      <DocumentHead />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="news" element={<NewsPage />} />
          <Route path="news/:slug" element={<NewsDetailPage />} />
          <Route path="projects" element={<ProjectsPage />} />
          <Route path="projects/:id" element={<ProjectDetailPage />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="reports/:slug" element={<ReportDetailPage />} />
          <Route path="statistics" element={<StatisticsPage />} />
          <Route path="statistics/:category" element={<StatisticsDetailPage />} />
          <Route path="health-statistics" element={<HealthStatisticsPage />} />
          <Route path="desil-statistics" element={<DesilStatisticsPage />} />
          <Route path="desa" element={<DesaTentangPage />} />
          <Route path="desa/lokasi" element={<DesaLokasiPage />} />
          <Route path="buku-tamu" element={<BukuTamuPage />} />
        </Route>
      </Routes>
      <Toaster position="top-right" />
    </>
  )
}

export default App
